import { useReveal } from "../hooks/useReveal";

const capabilities = [
  {
    domain: "Frontend Systems",
    annotation: "UI layer",
    tools: "React, Next.js, TypeScript",
    detail:
      "Component architectures, design systems, state management, SSR/SSG. Building interfaces that scale with the product.",
  },
  {
    domain: "Backend & APIs",
    annotation: "Service layer",
    tools: "NestJS, Spring Boot, Java",
    detail:
      "REST APIs, auth flows, job queues. Services that handle real traffic and real edge cases.",
  },
  {
    domain: "Architecture & Infrastructure",
    annotation: "System layer",
    tools: "Docker, CI/CD, Microservices",
    detail:
      "Database modeling, caching strategies, deployment pipelines, observability.",
  },
  {
    domain: "Product Engineering",
    annotation: "Delivery",
    tools: "End-to-end ownership",
    detail:
      "From requirements to production. I scope features, make technical trade-offs, ship increments, and own the outcome.",
  },
];

const About = () => {
  const [ref, visible] = useReveal(0.1);

  return (
    <section
      ref={ref}
      className="w-full bg-amber-50 px-2 md:px-8 border-y-3 border-black"
    >
      <div className="max-w-[1500px] mx-auto py-20 px-4 md:px-12">
        {/* Section header */}
        <div
          className={`flex items-end gap-6 mb-12 ${visible ? "reveal-left" : "reveal-hidden"}`}
        >
          <span className="text-6xl md:text-8xl font-black text-orange-600 leading-none">
            {"//"}
          </span>
          <div>
            <p className="text-2xl font-black uppercase tracking-tight">
              Engineering Capabilities
              <span className="text-orange-600">.</span>
            </p>
            <div
              className={`w-16 h-1 bg-black mt-2 ${visible ? "line-grow delay-200" : "reveal-hidden"}`}
            />
          </div>
        </div>

        {/* Staggered cards */}
        <div className="flex flex-col gap-6">
          {/* Row 1 */}
          <div className="flex flex-col md:flex-row gap-6">
            <div
              className={`md:w-[55%] border-3 border-black bg-white p-6 shadow-[5px_5px_0px_0px_#000] flex flex-col gap-3 ${visible ? "reveal-left delay-200" : "reveal-hidden"}`}
            >
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-black uppercase tracking-tight">
                  {capabilities[0].domain}
                </h3>
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-600 border border-orange-600 px-2 py-0.5">
                  {capabilities[0].annotation}
                </span>
              </div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wide">
                {capabilities[0].tools}
              </p>
              <p className="text-sm leading-relaxed">
                {capabilities[0].detail}
              </p>
            </div>
            <div
              className={`md:w-[45%] md:mt-8 border-3 border-black bg-white p-6 shadow-[5px_5px_0px_0px_#000] flex flex-col gap-3 ${visible ? "reveal-right delay-400" : "reveal-hidden"}`}
            >
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-black uppercase tracking-tight">
                  {capabilities[1].domain}
                </h3>
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-600 border border-orange-600 px-2 py-0.5">
                  {capabilities[1].annotation}
                </span>
              </div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wide">
                {capabilities[1].tools}
              </p>
              <p className="text-sm leading-relaxed">
                {capabilities[1].detail}
              </p>
            </div>
          </div>

          {/* Row 2 */}
          <div className="flex flex-col md:flex-row gap-6">
            <div
              className={`md:w-[45%] md:mt-4 border-3 border-black bg-white p-6 shadow-[5px_5px_0px_0px_#000] flex flex-col gap-3 ${visible ? "reveal-left delay-500" : "reveal-hidden"}`}
            >
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-black uppercase tracking-tight">
                  {capabilities[2].domain}
                </h3>
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-600 border border-orange-600 px-2 py-0.5">
                  {capabilities[2].annotation}
                </span>
              </div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wide">
                {capabilities[2].tools}
              </p>
              <p className="text-sm leading-relaxed">
                {capabilities[2].detail}
              </p>
            </div>
            <div
              className={`md:w-[55%] border-3 border-black bg-black text-white p-6 shadow-[5px_5px_0px_0px_#ea580c] flex flex-col gap-3 ${visible ? "reveal-scale delay-700" : "reveal-hidden"}`}
            >
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-black uppercase tracking-tight">
                  {capabilities[3].domain}
                </h3>
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-500 border border-orange-500 px-2 py-0.5">
                  {capabilities[3].annotation}
                </span>
              </div>
              <p className="text-xs font-bold text-gray-500 uppercase tracking-wide">
                {capabilities[3].tools}
              </p>
              <p className="text-sm leading-relaxed">
                {capabilities[3].detail}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
